import { analyzeWithChatGPT } from "../../../../../Api/reportApiService";
import { incrementUsageLimit } from "../../../../../Services/api";

const getLocalizedText = (t, language, key, ar, en) => t(key, language === "en" ? en : ar);

export const analyzeWithAI = async ({
  allowedModels,
  executionControl,
  filters,
  selectedReport,
  texts,
  toast,
  t,
  reportResponse,
  user,
}) => {
  const language = texts?.en === "Arabic" ? "ar" : "en";

  executionControl?.onProgress?.({
    progress: 45,
    hasStartedRun: false,
    stage: "sending-request",
    title: getLocalizedText(t, language, "reports.sendingAnalysisRequest", "جاري إرسال الطلب", "Sending analysis request"),
    description: getLocalizedText(
      t,
      language,
      "reports.sendingAnalysisRequestDesc",
      "سيتم الآن إرسال الطلب إلى خدمة الذكاء الاصطناعي.",
      "The request is being sent to the AI service."
    ),
  });

  toast({
    title: getLocalizedText(t, language, "reports.aiAnalysis", "جاري التحليل الذكي...", "AI analysis is running..."),
    description: getLocalizedText(
      t,
      language,
      "reports.analyzingData",
      filters.uploadedData ? "جاري تحليل البيانات مع ملف Excel المرفوع." : "جاري تحليل البيانات.",
      filters.uploadedData ? "Analyzing the report with the uploaded Excel data." : "Analyzing the report data."
    ),
    status: "info",
    duration: 3000,
    isClosable: true,
  });

  const aiResponse = await analyzeWithChatGPT(
    reportResponse.data,
    filters,
    selectedReport,
    reportResponse.originalData,
    texts?.en,
    filters.uploadedData,
    allowedModels,
    user,
    executionControl
  );

  const formattedAnalysis = aiResponse?.success ? aiResponse?.data?.report || null : null;

  if (aiResponse.success) {
    incrementUsageLimit(user?.CustomerId);
  }

  return {
    aiResponse,
    formattedAnalysis,
  };
};
